import { RentalStatus } from "../api/requests/interfaces/Channel";
import { DropdownSelectOption } from "./common";

export enum ProductCategory {
    TRANSPORTATION = "transportation",
    TOOLS = "tools",
    LEISURE = "leisure",
    HOME = "home",
    DEVICES = "devices",
    REALESTATE = "realestate",
    SERVICES = "services"
}
/* export enum ProductCategory {
    TRANSPORTATION = "transportation",
    DEVICES = "devices",
    REALESTATE = "realestate",
    SERVICES = "services"
} */

export const productCategoryOptions: DropdownSelectOption<ProductCategory>[] = [
    {
        value: ProductCategory.TOOLS,
        label: 'Tööriistad'
    },
    {
        value: ProductCategory.TRANSPORTATION,
        label: 'Sõidukid ja haagised'
    },
    {
        value: ProductCategory.DEVICES,
        label: 'Seadmed ja tehnika'
    },
    {
        value: ProductCategory.REALESTATE,
        label: 'Kinnisvara'
    },
    {
        value: ProductCategory.SERVICES,
        label: 'Teenused'
    }
]

export const productStatusOptions: DropdownSelectOption<RentalStatus>[] = [
    {
        value: RentalStatus.ARCHIVED,
        label: 'Arhiveeritud'
    },
    {
        value: RentalStatus.IN_RENT,
        label: 'Rendis'
    },
    {
        value: RentalStatus.MESSAGE_SENT,
        label: 'Sõnum saadetud'
    },
    {
        value: RentalStatus.RENT_FINISHED,
        label: 'Lõpetatud'
    }
]